import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

export const getSubscriptionPeriod = (payFrequencyMonth: number) => {
  if (payFrequencyMonth === 12) {
    return TEXTS.RATES_LIST_YEAR_TEXT;
  }

  return TEXTS.RATES_LIST_MONTH_TEXT;
};
